import { Box, Spinner, Text } from '@frameio/vapor';
import TEXT from './generated/TEXT/CancelingJobStatus';

TEXT.DEFINE({
  /** Status label when transfer is being canceled */
  canceling: 'Canceling…',
  /** Aria label for spinner when canceling */
  cancelingAriaLabel: 'Canceling',
});

export const CancelingJobStatus = () => {
  return (
    <>
      <Box data-chromatic="ignore" paddingRight={4}>
        <Spinner
          aria-label={TEXT.cancelingAriaLabel}
          delay={0}
          isLoading={true}
          size="xx-small"
        />
      </Box>
      <Text color="body" variant="secondary">
        {TEXT.canceling}
      </Text>
    </>
  );
};
